import React from 'react';
import Title from '../shared/Title';

const CareersTittle = () => {
  return (
    <div className="bg-custom md:px-52 py-20 px-10">
      <div className="3xl:max-w-[1500px] 3xl:inline-block">
        <h1>
          <Title text1="Careers" colorForText={1} isLight={true} />
        </h1>
        <p className='text-white-50 md:flex md: justify-center text-center mb-5 font-normal text-xl flex items-center'>Explore our current vacancies and discover how you can grow professionally within our company.</p>
      </div>
    </div>
  );
};

export default CareersTittle;
